import React, { useState } from "react";
import { getAppShortName, getBrandIconUrl } from "../../config/chains";

type SVGProps = React.SVGAttributes<SVGElement>;

/**
 * Brand logo icon — renders the active chain's icon
 * (`/assets/logo/<brand>/logo_icon.png`). If the icon fails to load we render
 * nothing: showing no logo is better than showing another brand's logo. There
 * is deliberately NO hard-coded fallback mark.
 */
export function Logo({
  color,
  ...props
}: SVGProps & { color?: string }): JSX.Element | null {
  const [errored, setErrored] = useState(false);
  const { width, height, className, style } = props;

  if (errored) return null;

  return (
    <img
      src={getBrandIconUrl()}
      alt={`${getAppShortName()} logo`}
      width={width as number | string | undefined}
      height={height as number | string | undefined}
      className={className}
      style={style}
      onError={() => setErrored(true)}
    />
  );
}
